import { render, staticRenderFns } from "./TakipAcView.vue?vue&type=template&id=7daa2d0f"
import script from "./TakipAcView.vue?vue&type=script&lang=ts"
export * from "./TakipAcView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports